export default {
  primary: '#ee7206',
  grey3: '#666f7a',
};
